import React, { useEffect, useState } from "react";

function DateTimeDisplay() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 1000); // every second

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="date-time">
      {now.toLocaleString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit"
      })}
    </div>
  );
}

export default DateTimeDisplay;
